import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErrorMessage } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import Logo from "../../components/Logo";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email, origin: window.location.origin });
            setSent(true);
        } catch (err) {
            setError(apiErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-8" data-testid="forgot-password-page">
            <div className="w-full max-w-md">
                <div className="mb-8"><Logo /></div>
                <div className="label-mono mb-2">/ Password recovery</div>
                <h1 className="font-heading font-black text-3xl tracking-tighter mb-2">Forgot your password?</h1>
                <p className="text-sm text-avx-muted mb-8">
                    Enter your email and we'll send you a link to reset your password.
                </p>

                {sent ? (
                    <div className="panel p-6" data-testid="forgot-password-sent">
                        <p className="text-sm text-avx-text">
                            If an account exists for <strong>{email}</strong>, we've sent a reset link.
                            Check your inbox (and spam folder). The link expires in 1 hour.
                        </p>
                        <Link to="/login" className="btn-primary inline-block mt-6 px-5 py-2.5 text-xs font-mono uppercase tracking-[0.2em] rounded-sm" data-testid="forgot-back-to-login">
                            Back to login
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={submit} data-testid="forgot-password-form">
                        {error && (
                            <div className="mb-4 p-3 border border-avx-danger/40 bg-avx-danger/10 text-avx-danger text-sm rounded-sm" data-testid="forgot-password-error">
                                {error}
                            </div>
                        )}
                        <div className="mb-6">
                            <Label htmlFor="email" className="label-mono">Email</Label>
                            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input"
                                className="mt-2 bg-avx-surface border-avx-line h-11 focus:border-avx-blue focus:ring-1 focus:ring-avx-blue" />
                        </div>
                        <button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                            className="btn-primary w-full py-3 text-xs font-mono uppercase tracking-[0.2em] rounded-sm">
                            {loading ? "Sending…" : "Send reset link"}
                        </button>
                        <div className="mt-6 text-xs">
                            <Link to="/login" className="text-avx-muted hover:text-avx-blue font-mono uppercase tracking-[0.18em]">
                                ← Back to login
                            </Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
